import { AnimationRefs } from '../../../hooks/use-animation-refs';
import { Viewport } from '../../../hooks/use-viewport';
import { animateStars } from '../../helpers/animate-stars';

export function buildStage5(tl: GSAPTimeline, refs: AnimationRefs, viewport: Viewport) {
  const { vw, vh } = viewport;

  tl.to(
    refs.texts.prayerPre.current,
    {
      alpha: 0,
      duration: 1,
    },
    'stage5'
  );
  tl.to(
    refs.prayer.encouragementMsgContainerRef.current,
    {
      alpha: 1,
      duration: 1,
    },
    'stage5'
  );

  animateStars({
    tl,
    stars: refs.stars,
    label: 'stage5',
    animations: [
      { x: vw(0.42), y: vh(-0.53), scale: 1.35, duration: 1 },
      { x: vw(0.018), y: vh(-0.57), scale: 1.35, duration: 1 },
      { x: vw(0.37), y: vh(-0.283), scale: 1.35, duration: 1 },
      { x: vw(-0.411), y: vh(-0.538), scale: 1.35, duration: 1 },
      { x: vw(-0.375), y: vh(-0.282), scale: 1.35, duration: 1 },
      { x: vw(-0), y: vh(-0.2), scale: 1.35, duration: 1 },
    ],
  });
}
